// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WbZuOLWS5ApyyhQ2 .p-multiselect-label {
  flex-wrap: wrap;
  display: flex;
  row-gap: 5px;
}

.VZHlKgu68EEw64on {
  min-height: calc(100vh - 97px);
  padding: 44px 0px 176px;
  background-color: #f3f5f7;
}

.dpkk74qp6Y3Fm_ys {
  width: 996px;
  margin: 0 auto;
  border-radius: 51px;
  overflow: hidden;
  background-color: #f2efea;
}

.iUSCNbNBN_AKZ2ay {
  height: 328px;
  background-color: gray;
  background-size: cover;
  background-position: center;
  position: relative;
}

.ng9nWfvs7eczbfsS {
  position: absolute;
  top: 28px;
  left: 55px;
  background-color: #ffffff;
  border-radius: 50%;
  width: 53px;
  height: 53px;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  border: none;
  cursor: pointer;
  text-decoration: none;
}

.ng9nWfvs7eczbfsS i {
  font-size: 28px;
  margin-right: 3px;
}

.Akx7howLSa4SK_X2 {
  position: absolute;
  top: 36px;
  right: 55px;
  font-size: 16px;
  font-family: "Roboto";
  padding: 10px 21px;
  background-color: #c84014;
  border-radius: 16px;
  color: #ffffff;
  border: 1px solid #ffffff;
}

.c9CyMaHBZUoq0KCJ {
  padding: 40px 70px 132px;
}

.Yg5DQ9eBnMGpd6x6 {
  text-align: center;
  font-weight: 200;
  font-style: italic;
  margin-top: 0px;
  margin-bottom: 42px;
  font-size: 16px;
}

.dpkk74qp6Y3Fm_ys h1 {
  padding: 0px;
  margin: 0px;
  text-align: center;
  font-family: "Roboto";
  font-size: 36px;
  font-weight: 900;
  text-transform: uppercase;
  margin-bottom: 56px;
}

.qiWes9zanxURGKWr {
  display: flex;
  gap: 19px;
}

.gxq4nhNttNEZ2vuO {
  display: block;
  font-family: "Roboto";
  font-weight: bold;
  font-size: 24px;
  color: #000000;
  margin-bottom: 17px;
}

.jpFZDGQrtCY2ZLUL {
  font-size: 16px !important;
}

.u7nYnngWq4nkyfI0 {
  display: flex;
  align-items: center;
  height: 100%;
  gap: 12px;
  margin-bottom: 28px;
}

.u7nYnngWq4nkyfI0 .p-checkbox {
  width: 36px;
  height: 36px;
}

.eKl8wzMf9hgrzbzR .p-checkbox-box {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 6px;
}

.eKl8wzMf9hgrzbzR .p-checkbox-box .p-checkbox-icon {
  width: 20px;
  height: 20px;
}

.SFJwRya67wQcsO3N {
  font-family: "Roboto";
  font-size: 18px;
  color: #000000;
  cursor: pointer;
  user-select: none;
}

.e71OuuFDcUp_JTYC {
  margin-bottom: 52px;
  width: 100%;
}

.th4KfdegYq0C1K1b {
  padding: 22px 32px 24px;
  border-radius: 24px;
  font-size: 21px;
  height: 66px;
  font-family: "Roboto";
}

.qfAcp3qZY9EUhPZX {
  border-radius: 24px 0 0 24px;
  padding: 19px 6px 22px 32px;
  height: 66px;
  font-size: 21px;
  display: inline-block;
  -webkit-text-size-adjust: 100%;
}

.ZESGPvB4Sa0KT3qF {
  border-radius: 0 24px 24px 0;
  padding-left: 4px;
}

.H05UKXOudQYDl3gF {
  display: flex;
  align-items: center;
  width: 100%;
}

.H05UKXOudQYDl3gF > div {
  width: 80px;
  height: 80px;
  background-size: cover;
  background-color: #eeeeee;
  margin-right: 10px;
  border-radius: 6px;
  flex-shrink: 0;
}

.KvIIRVZU1KcpFgSP {
  flex: 1;
  min-width: 0;
}

.UMh600JkgoQpb5w3 {
  margin-bottom: 52px;
}

.QpMFRGTy1iIjQfuh {
  margin-bottom: 52px;
}

.IgzaZwb6KQNUUBVZ {
  margin-bottom: 20px;
}

.UMh600JkgoQpb5w3 .p-dropdown {
  width: 100%;
  height: 66px;
  border-radius: 24px;
}

.UMh600JkgoQpb5w3 .p-dropdown-label {
  display: block;
  padding: 17px 32px 24px;
  font-size: 21px;
  font-family: "Roboto";
}

.XVcT5ZpA_QI7xSMI {
  border-radius: 24px;
  border: 1px solid #a4a4a4;
  overflow: hidden;
  padding: 16px 34px;
}

.XVcT5ZpA_QI7xSMI .p-dropdown-items-wrapper {
  max-height: 400px !important;
}

.XVcT5ZpA_QI7xSMI .p-dropdown-items li {
  height: 88px;
  border-radius: 6px;
  margin: 4px 0px;
  padding: 4px;
}

.dNoS3SUkuXEVVoWI.XVcT5ZpA_QI7xSMI .p-dropdown-items li {
  height: 57px;
  border-radius: 15px;
  margin: 4px 0px;
  padding: 21px 15px;
}

.XVcT5ZpA_QI7xSMI .p-dropdown-item:not(.p-highlight):not(.p-disabled) {
  border: 2px solid transparent;
}

.XVcT5ZpA_QI7xSMI
  .p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus {
  border: 2px solid #20336c;
  background-color: inherit;
}

.XVcT5ZpA_QI7xSMI .p-dropdown-item:not(.p-highlight):not(.p-disabled) {
  background-color: inherit;
}

.XVcT5ZpA_QI7xSMI .p-dropdown-item.p-highlight {
  color: #ffffff;
  background-color: #20336c;
}

.XVcT5ZpA_QI7xSMI .p-dropdown-item.p-highlight:after {
  content: "✓";
  position: absolute;
  right: 16px;
  font-size: 24px;
  color: #ffffff;
}

.QCn2pSDRDwn9ml2e {
  margin-bottom: 52px;
}

.QCn2pSDRDwn9ml2e.FZUlWTAttbkUNHm2 {
  margin-bottom: 52px;
}

.QCn2pSDRDwn9ml2e .p-multiselect {
  width: 100%;
  border-radius: 24px;
}

.QCn2pSDRDwn9ml2e .p-multiselect-token {
  background-color: #20336c15;
  border-radius: 100px;
}

.QCn2pSDRDwn9ml2e .p-multiselect-label {
  padding: 17px 32px 24px;
  font-size: 21px;
  font-family: "Roboto";
}

.pKQqnIEAswxWr1rQ {
  border-radius: 24px;
  border: 1px solid #a4a4a4;
  overflow: hidden;
  padding: 16px 34px;
}

.pKQqnIEAswxWr1rQ .p-multiselect-items-wrapper {
  max-height: 400px !important;
}

.pKQqnIEAswxWr1rQ .p-multiselect-header {
  display: none;
}

.pKQqnIEAswxWr1rQ .p-multiselect-items li {
  height: 88px;
  border-radius: 6px;
  margin: 4px 0px;
  padding: 4px;
}

.dNoS3SUkuXEVVoWI.pKQqnIEAswxWr1rQ .p-multiselect-items li {
  height: 57px;
  border-radius: 15px;
  margin: 4px 0px;
  padding: 21px 15px;
}

.pKQqnIEAswxWr1rQ
  .p-multiselect-item:not(.p-highlight):not(.p-disabled) {
  border: 2px solid transparent;
}

.pKQqnIEAswxWr1rQ
  .p-multiselect-item:not(.p-highlight):not(.p-disabled).p-focus {
  border: 2px solid #20336c;
  background-color: inherit;
}

.pKQqnIEAswxWr1rQ
  .p-multiselect-item:not(.p-highlight):not(.p-disabled) {
  background-color: inherit;
}

.pKQqnIEAswxWr1rQ .p-multiselect-item.p-highlight {
  color: #ffffff;
  background-color: #20336c;
}

.pKQqnIEAswxWr1rQ .p-multiselect-item.p-highlight:after {
  content: "✓";
  position: absolute;
  right: 16px;
  font-size: 24px;
  color: #ffffff;
}

.pKQqnIEAswxWr1rQ .p-multiselect-checkbox {
  display: none;
}

.j2WOSF_wAvo5UIKe {
  resize: none;
  border-radius: 24px;
  height: 132px;
  padding: 15px;
  margin-bottom: 52px;
}

.DwMAiD0cZXg3vyWF {
  border: 1px solid transparent;
  border-radius: 16px;
  width: 100%;
  height: 44px;
  background-color: #f9f9f9f9;
  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);
}

.DwMAiD0cZXg3vyWF:hover {
  border-color: #20336c;
}

.X2Dr0yjXwCI2rV0e {
  color: #20336c;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 38px;
  height: fit-content;
}

.X2Dr0yjXwCI2rV0e:hover {
  border-color: transparent;
}

.X2Dr0yjXwCI2rV0e:active {
  background-color: #dedede;
}

.BY3M6mZ5hgkatAYT {
  font-size: 16px;
}

.wEzXo3nqvmI_8PPc {
  text-align: left;
}

.GAfoVOi6MOoPN02J {
  color: #f44336;
  margin-left: 15px;
}

.aYKTEFsLkHw7yA3a {
  border-radius: 24px;
  background-color: #20336c;
  font-family: "Roboto";
  font-weight: 900;
  font-size: 30px;
  text-transform: uppercase;
  width: 100%;
  padding: 24px;
}

.Na8cjWJQlBouwLSN {
  text-align: center;
  font-size: 20px;
}

.mdeS5tvQk5EnO50b {
  margin-top: 5px;
  padding-left: 5px;
  font-size: 14px;
}

.JVOEmHexfZoUU5ft {
  margin-left: 4px;
  text-decoration: underline;
  color: #20336c;
  cursor: pointer;
}

.QfGsdYq3r3ELjIh_ p {
  text-align: center;
  max-width: 400px;
  margin: 0 auto;
  margin-bottom: 20px;
}

@media screen and (max-width: 1024px) {
  .VZHlKgu68EEw64on {
    min-height: auto;
    padding: 0px;
  }

  .dpkk74qp6Y3Fm_ys {
    width: 100%;
    border: none;
    box-shadow: none;
    border-radius: 0px;
    padding-bottom: 108px;
  }

  .iUSCNbNBN_AKZ2ay {
    height: 204px;
  }

  .ng9nWfvs7eczbfsS {
    top: 20px;
    left: 30px;
    border-radius: 50%;
    width: 34px;
    height: 34px;
    outline: none;
    border: none;
  }

  .ng9nWfvs7eczbfsS i {
    font-size: 24px;
    margin-right: 2px;
  }

  .Akx7howLSa4SK_X2 {
    top: 27px;
    right: 30px;
    font-size: 10px;
    padding: 6px 6px;
  }

  .c9CyMaHBZUoq0KCJ {
    padding: 25px 25px 85px;
    padding-bottom: 0px;
  }

  .Yg5DQ9eBnMGpd6x6 {
    margin-top: 0px;
    margin-bottom: 25px;
    font-size: 12px;
  }

  .dpkk74qp6Y3Fm_ys h1 {
    padding: 0px;
    margin: 0px;
    text-align: center;
    font-family: "Roboto";
    font-size: 20px;
    font-weight: 900;
    margin-bottom: 40px;
  }

  .u7nYnngWq4nkyfI0 .p-checkbox {
    width: 30px;
    height: 30px;
  }

  .eKl8wzMf9hgrzbzR .p-checkbox-box {
    flex-shrink: 0;
    width: 30px;
    height: 30px;
    border-radius: 6px;
  }

  .eKl8wzMf9hgrzbzR .p-checkbox-box .p-checkbox-icon {
    width: 20px;
    height: 20px;
  }

  .SFJwRya67wQcsO3N {
    font-size: 16px;
  }

  .qiWes9zanxURGKWr {
    flex-direction: column;
    gap: 6px;
    margin-bottom: 38px;
  }

  .qiWes9zanxURGKWr .e71OuuFDcUp_JTYC,
  .qiWes9zanxURGKWr .th4KfdegYq0C1K1b {
    margin: 0px;
  }

  .QfGsdYq3r3ELjIh_ {
    max-width: 400px;
    margin: 0 auto;
    margin-bottom: 20px;
  }

  .gxq4nhNttNEZ2vuO {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 12px;
  }

  .th4KfdegYq0C1K1b {
    padding: 17px 22px;
    border-radius: 16px;
    font-size: 16px;
    height: 44px;
    margin-bottom: 38px;
  }

  .qfAcp3qZY9EUhPZX {
    padding: 13px 6px 22px 32px;
    height: 44px;
    font-size: 14px;
  }

  .ZESGPvB4Sa0KT3qF {
    border-radius: 0 24px 24px 0;
    padding-left: 4px;
    margin: 0px;
  }

  .CoAkmPJ9RfsToAAF {
    margin: 0;
    margin-top: 14px;
    font-size: 10px;
  }

  .H05UKXOudQYDl3gF > div {
    width: 54px;
    height: 54px;
    margin-right: 18px;
    border-radius: 4px;
  }

  .UMh600JkgoQpb5w3 {
    margin-bottom: 38px;
  }

  .UMh600JkgoQpb5w3 .p-dropdown {
    height: 44px;
    border-radius: 16px;
  }

  .UMh600JkgoQpb5w3 .p-dropdown-label {
    padding: 13px 22px;
    font-size: 16px;
  }

  .XVcT5ZpA_QI7xSMI {
    border-radius: 16px;
    padding: 18px 11px;
  }

  .XVcT5ZpA_QI7xSMI .p-dropdown-items-wrapper {
    max-height: 270px !important;
  }

  .XVcT5ZpA_QI7xSMI .p-dropdown-items {
    margin: 0px;
    padding: 0px;
  }

  .XVcT5ZpA_QI7xSMI .p-dropdown-items li {
    height: 60px;
    border-radius: 4px;
    margin: 2px 0px;
  }

  .dNoS3SUkuXEVVoWI.XVcT5ZpA_QI7xSMI .p-dropdown-items li {
    height: 38px;
    border-radius: 10px;
    padding: 14px 11px;
    font-size: 14px;
    margin: 2px 0px;
  }

  .XVcT5ZpA_QI7xSMI .p-dropdown-item.p-highlight:after {
    font-size: 14px;
  }

  .QCn2pSDRDwn9ml2e {
    margin-bottom: 38px;
  }

  .QCn2pSDRDwn9ml2e.FZUlWTAttbkUNHm2 {
    margin-bottom: 38px;
  }

  .QCn2pSDRDwn9ml2e .p-multiselect {
    border-radius: 16px;
  }

  .QCn2pSDRDwn9ml2e .p-multiselect-label {
    padding: 13px 22px;
    font-size: 16px;
  }

  .pKQqnIEAswxWr1rQ {
    border-radius: 16px;
    padding: 18px 11px;
  }

  .pKQqnIEAswxWr1rQ .p-multiselect-items-wrapper {
    max-height: 270px !important;
  }

  .pKQqnIEAswxWr1rQ .p-multiselect-items {
    margin: 0px;
    padding: 0px;
  }

  .pKQqnIEAswxWr1rQ .p-multiselect-items li {
    height: 60px;
    border-radius: 4px;
    margin: 2px 0px;
  }

  .dNoS3SUkuXEVVoWI.pKQqnIEAswxWr1rQ .p-multiselect-items li {
    height: 38px;
    border-radius: 10px;
    margin: 2px 0px;
    padding: 14px 11px;
  }

  .pKQqnIEAswxWr1rQ .p-multiselect-item.p-highlight:after {
    font-size: 14px;
  }

  .j2WOSF_wAvo5UIKe {
    border-radius: 16px;
    height: 88px;
    padding: 12px;
    margin-bottom: 38px;
    font-size: 14px;
  }

  .aYKTEFsLkHw7yA3a {
    border-radius: 16px;
    font-size: 16px;
    padding: 17px;
  }

  .Na8cjWJQlBouwLSN {
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Student/OrderPage/OrderPage.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,YAAY;EACd;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;IAC3B,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,4BAA4B;IAC5B,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".multiSelect :global(.p-multiselect-label) {\r\n  flex-wrap: wrap;\r\n  display: flex;\r\n  row-gap: 5px;\r\n}\r\n\r\n.pageWrapper {\r\n  min-height: calc(100vh - 97px);\r\n  padding: 44px 0px 176px;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.orderCard {\r\n  width: 996px;\r\n  margin: 0 auto;\r\n  border-radius: 51px;\r\n  overflow: hidden;\r\n  background-color: #f2efea;\r\n}\r\n\r\n.stationImage {\r\n  height: 328px;\r\n  background-color: gray;\r\n  background-size: cover;\r\n  background-position: center;\r\n  position: relative;\r\n}\r\n\r\n.backButton {\r\n  position: absolute;\r\n  top: 28px;\r\n  left: 55px;\r\n  background-color: #ffffff;\r\n  border-radius: 50%;\r\n  width: 53px;\r\n  height: 53px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  outline: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  text-decoration: none;\r\n}\r\n\r\n.backButton i {\r\n  font-size: 28px;\r\n  margin-right: 3px;\r\n}\r\n\r\n.estimatedTime {\r\n  position: absolute;\r\n  top: 36px;\r\n  right: 55px;\r\n  font-size: 16px;\r\n  font-family: \"Roboto\";\r\n  padding: 10px 21px;\r\n  background-color: #c84014;\r\n  border-radius: 16px;\r\n  color: #ffffff;\r\n  border: 1px solid #ffffff;\r\n}\r\n\r\n.formWrapper {\r\n  padding: 40px 70px 132px;\r\n}\r\n\r\n.orderRestrictions {\r\n  text-align: center;\r\n  font-weight: 200;\r\n  font-style: italic;\r\n  margin-top: 0px;\r\n  margin-bottom: 42px;\r\n  font-size: 16px;\r\n}\r\n\r\n.orderCard h1 {\r\n  padding: 0px;\r\n  margin: 0px;\r\n  text-align: center;\r\n  font-family: \"Roboto\";\r\n  font-size: 36px;\r\n  font-weight: 900;\r\n  text-transform: uppercase;\r\n  margin-bottom: 56px;\r\n}\r\n\r\n.nameWrapper {\r\n  display: flex;\r\n  gap: 19px;\r\n}\r\n\r\n.label {\r\n  display: block;\r\n  font-family: \"Roboto\";\r\n  font-weight: bold;\r\n  font-size: 24px;\r\n  color: #000000;\r\n  margin-bottom: 17px;\r\n}\r\n\r\n.maxOptionsLabel {\r\n  font-size: 16px !important;\r\n}\r\n\r\n.allergenToggleRow {\r\n  display: flex;\r\n  align-items: center;\r\n  height: 100%;\r\n  gap: 12px;\r\n  margin-bottom: 28px;\r\n}\r\n\r\n.allergenToggleRow :global(.p-checkbox) {\r\n  width: 36px;\r\n  height: 36px;\r\n}\r\n\r\n.allergenCheckbox :global(.p-checkbox-box) {\r\n  flex-shrink: 0;\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: 6px;\r\n}\r\n\r\n.allergenCheckbox :global(.p-checkbox-box .p-checkbox-icon) {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n.allergenToggleLabel {\r\n  font-family: \"Roboto\";\r\n  font-size: 18px;\r\n  color: #000000;\r\n  cursor: pointer;\r\n  user-select: none;\r\n}\r\n\r\n.inputWrapper {\r\n  margin-bottom: 52px;\r\n  width: 100%;\r\n}\r\n\r\n.input {\r\n  padding: 22px 32px 24px;\r\n  border-radius: 24px;\r\n  font-size: 21px;\r\n  height: 66px;\r\n  font-family: \"Roboto\";\r\n}\r\n\r\n.phonePrefix {\r\n  border-radius: 24px 0 0 24px;\r\n  padding: 19px 6px 22px 32px;\r\n  height: 66px;\r\n  font-size: 21px;\r\n  display: inline-block;\r\n  -webkit-text-size-adjust: 100%;\r\n}\r\n\r\n.phoneInput {\r\n  border-radius: 0 24px 24px 0;\r\n  padding-left: 4px;\r\n}\r\n\r\n.listItem {\r\n  display: flex;\r\n  align-items: center;\r\n  width: 100%;\r\n}\r\n\r\n.listItem > div {\r\n  width: 80px;\r\n  height: 80px;\r\n  background-size: cover;\r\n  background-color: #eeeeee;\r\n  margin-right: 10px;\r\n  border-radius: 6px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.listItemLabel {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.dropDownWrapper {\r\n  margin-bottom: 52px;\r\n}\r\n\r\n.notificationDropdown {\r\n  margin-bottom: 52px;\r\n}\r\n\r\n.notificationDropdownSelected {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.dropDownWrapper :global(.p-dropdown) {\r\n  width: 100%;\r\n  height: 66px;\r\n  border-radius: 24px;\r\n}\r\n\r\n.dropDownWrapper :global(.p-dropdown-label) {\r\n  display: block;\r\n  padding: 17px 32px 24px;\r\n  font-size: 21px;\r\n  font-family: \"Roboto\";\r\n}\r\n\r\n.dropDownPanel {\r\n  border-radius: 24px;\r\n  border: 1px solid #a4a4a4;\r\n  overflow: hidden;\r\n  padding: 16px 34px;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-items-wrapper) {\r\n  max-height: 400px !important;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-items) li {\r\n  height: 88px;\r\n  border-radius: 6px;\r\n  margin: 4px 0px;\r\n  padding: 4px;\r\n}\r\n\r\n.withOutImage.dropDownPanel :global(.p-dropdown-items) li {\r\n  height: 57px;\r\n  border-radius: 15px;\r\n  margin: 4px 0px;\r\n  padding: 21px 15px;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item:not(.p-highlight):not(.p-disabled)) {\r\n  border: 2px solid transparent;\r\n}\r\n\r\n.dropDownPanel\r\n  :global(.p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus) {\r\n  border: 2px solid #20336c;\r\n  background-color: inherit;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item:not(.p-highlight):not(.p-disabled)) {\r\n  background-color: inherit;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item.p-highlight) {\r\n  color: #ffffff;\r\n  background-color: #20336c;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item.p-highlight:after) {\r\n  content: \"✓\";\r\n  position: absolute;\r\n  right: 16px;\r\n  font-size: 24px;\r\n  color: #ffffff;\r\n}\r\n\r\n.multiSelectWrapper {\r\n  margin-bottom: 52px;\r\n}\r\n\r\n.multiSelectWrapper.allergiesWrapper {\r\n  margin-bottom: 52px;\r\n}\r\n\r\n.multiSelectWrapper :global(.p-multiselect) {\r\n  width: 100%;\r\n  border-radius: 24px;\r\n}\r\n\r\n.multiSelectWrapper :global(.p-multiselect-token) {\r\n  background-color: #20336c15;\r\n  border-radius: 100px;\r\n}\r\n\r\n.multiSelectWrapper :global(.p-multiselect-label) {\r\n  padding: 17px 32px 24px;\r\n  font-size: 21px;\r\n  font-family: \"Roboto\";\r\n}\r\n\r\n.multiSelectPanel {\r\n  border-radius: 24px;\r\n  border: 1px solid #a4a4a4;\r\n  overflow: hidden;\r\n  padding: 16px 34px;\r\n}\r\n\r\n.multiSelectPanel :global(.p-multiselect-items-wrapper) {\r\n  max-height: 400px !important;\r\n}\r\n\r\n.multiSelectPanel :global(.p-multiselect-header) {\r\n  display: none;\r\n}\r\n\r\n.multiSelectPanel :global(.p-multiselect-items) li {\r\n  height: 88px;\r\n  border-radius: 6px;\r\n  margin: 4px 0px;\r\n  padding: 4px;\r\n}\r\n\r\n.withOutImage.multiSelectPanel :global(.p-multiselect-items) li {\r\n  height: 57px;\r\n  border-radius: 15px;\r\n  margin: 4px 0px;\r\n  padding: 21px 15px;\r\n}\r\n\r\n.multiSelectPanel\r\n  :global(.p-multiselect-item:not(.p-highlight):not(.p-disabled)) {\r\n  border: 2px solid transparent;\r\n}\r\n\r\n.multiSelectPanel\r\n  :global(.p-multiselect-item:not(.p-highlight):not(.p-disabled).p-focus) {\r\n  border: 2px solid #20336c;\r\n  background-color: inherit;\r\n}\r\n\r\n.multiSelectPanel\r\n  :global(.p-multiselect-item:not(.p-highlight):not(.p-disabled)) {\r\n  background-color: inherit;\r\n}\r\n\r\n.multiSelectPanel :global(.p-multiselect-item.p-highlight) {\r\n  color: #ffffff;\r\n  background-color: #20336c;\r\n}\r\n\r\n.multiSelectPanel :global(.p-multiselect-item.p-highlight:after) {\r\n  content: \"✓\";\r\n  position: absolute;\r\n  right: 16px;\r\n  font-size: 24px;\r\n  color: #ffffff;\r\n}\r\n\r\n.multiSelectPanel :global(.p-multiselect-checkbox) {\r\n  display: none;\r\n}\r\n\r\n.textArea {\r\n  resize: none;\r\n  border-radius: 24px;\r\n  height: 132px;\r\n  padding: 15px;\r\n  margin-bottom: 52px;\r\n}\r\n\r\n.orderPageInput {\r\n  border: 1px solid transparent;\r\n  border-radius: 16px;\r\n  width: 100%;\r\n  height: 44px;\r\n  background-color: #f9f9f9f9;\r\n  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.orderPageInput:hover {\r\n  border-color: #20336c;\r\n}\r\n\r\n.mobileSelectBtn {\r\n  color: #20336c;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 38px;\r\n  height: fit-content;\r\n}\r\n\r\n.mobileSelectBtn:hover {\r\n  border-color: transparent;\r\n}\r\n\r\n.mobileSelectBtn:active {\r\n  background-color: #dedede;\r\n}\r\n\r\n.mobileSelectBtnText {\r\n  font-size: 16px;\r\n}\r\n\r\n.chipsWrapper {\r\n  text-align: left;\r\n}\r\n\r\n.error {\r\n  color: #f44336;\r\n  margin-left: 15px;\r\n}\r\n\r\n.submitButton {\r\n  border-radius: 24px;\r\n  background-color: #20336c;\r\n  font-family: \"Roboto\";\r\n  font-weight: 900;\r\n  font-size: 30px;\r\n  text-transform: uppercase;\r\n  width: 100%;\r\n  padding: 24px;\r\n}\r\n\r\n.orderCreated {\r\n  text-align: center;\r\n  font-size: 20px;\r\n}\r\n\r\n.pushMobileInfoText {\r\n  margin-top: 5px;\r\n  padding-left: 5px;\r\n  font-size: 14px;\r\n}\r\n\r\n.installLink {\r\n  margin-left: 4px;\r\n  text-decoration: underline;\r\n  color: #20336c;\r\n  cursor: pointer;\r\n}\r\n\r\n.stationInfo p {\r\n  text-align: center;\r\n  max-width: 400px;\r\n  margin: 0 auto;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n@media screen and (max-width: 1024px) {\r\n  .pageWrapper {\r\n    min-height: auto;\r\n    padding: 0px;\r\n  }\r\n\r\n  .orderCard {\r\n    width: 100%;\r\n    border: none;\r\n    box-shadow: none;\r\n    border-radius: 0px;\r\n    padding-bottom: 108px;\r\n  }\r\n\r\n  .stationImage {\r\n    height: 204px;\r\n  }\r\n\r\n  .backButton {\r\n    top: 20px;\r\n    left: 30px;\r\n    border-radius: 50%;\r\n    width: 34px;\r\n    height: 34px;\r\n    outline: none;\r\n    border: none;\r\n  }\r\n\r\n  .backButton i {\r\n    font-size: 24px;\r\n    margin-right: 2px;\r\n  }\r\n\r\n  .estimatedTime {\r\n    top: 27px;\r\n    right: 30px;\r\n    font-size: 10px;\r\n    padding: 6px 6px;\r\n  }\r\n\r\n  .formWrapper {\r\n    padding: 25px 25px 85px;\r\n    padding-bottom: 0px;\r\n  }\r\n\r\n  .orderRestrictions {\r\n    margin-top: 0px;\r\n    margin-bottom: 25px;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .orderCard h1 {\r\n    padding: 0px;\r\n    margin: 0px;\r\n    text-align: center;\r\n    font-family: \"Roboto\";\r\n    font-size: 20px;\r\n    font-weight: 900;\r\n    margin-bottom: 40px;\r\n  }\r\n\r\n  .allergenToggleRow :global(.p-checkbox) {\r\n    width: 30px;\r\n    height: 30px;\r\n  }\r\n\r\n  .allergenCheckbox :global(.p-checkbox-box) {\r\n    flex-shrink: 0;\r\n    width: 30px;\r\n    height: 30px;\r\n    border-radius: 6px;\r\n  }\r\n\r\n  .allergenCheckbox :global(.p-checkbox-box .p-checkbox-icon) {\r\n    width: 20px;\r\n    height: 20px;\r\n  }\r\n\r\n  .allergenToggleLabel {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .nameWrapper {\r\n    flex-direction: column;\r\n    gap: 6px;\r\n    margin-bottom: 38px;\r\n  }\r\n\r\n  .nameWrapper .inputWrapper,\r\n  .nameWrapper .input {\r\n    margin: 0px;\r\n  }\r\n\r\n  .stationInfo {\r\n    max-width: 400px;\r\n    margin: 0 auto;\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .label {\r\n    font-weight: bold;\r\n    font-size: 16px;\r\n    margin-bottom: 12px;\r\n  }\r\n\r\n  .input {\r\n    padding: 17px 22px;\r\n    border-radius: 16px;\r\n    font-size: 16px;\r\n    height: 44px;\r\n    margin-bottom: 38px;\r\n  }\r\n\r\n  .phonePrefix {\r\n    padding: 13px 6px 22px 32px;\r\n    height: 44px;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .phoneInput {\r\n    border-radius: 0 24px 24px 0;\r\n    padding-left: 4px;\r\n    margin: 0px;\r\n  }\r\n\r\n  .phoneNote {\r\n    margin: 0;\r\n    margin-top: 14px;\r\n    font-size: 10px;\r\n  }\r\n\r\n  .listItem > div {\r\n    width: 54px;\r\n    height: 54px;\r\n    margin-right: 18px;\r\n    border-radius: 4px;\r\n  }\r\n\r\n  .dropDownWrapper {\r\n    margin-bottom: 38px;\r\n  }\r\n\r\n  .dropDownWrapper :global(.p-dropdown) {\r\n    height: 44px;\r\n    border-radius: 16px;\r\n  }\r\n\r\n  .dropDownWrapper :global(.p-dropdown-label) {\r\n    padding: 13px 22px;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .dropDownPanel {\r\n    border-radius: 16px;\r\n    padding: 18px 11px;\r\n  }\r\n\r\n  .dropDownPanel :global(.p-dropdown-items-wrapper) {\r\n    max-height: 270px !important;\r\n  }\r\n\r\n  .dropDownPanel :global(.p-dropdown-items) {\r\n    margin: 0px;\r\n    padding: 0px;\r\n  }\r\n\r\n  .dropDownPanel :global(.p-dropdown-items) li {\r\n    height: 60px;\r\n    border-radius: 4px;\r\n    margin: 2px 0px;\r\n  }\r\n\r\n  .withOutImage.dropDownPanel :global(.p-dropdown-items) li {\r\n    height: 38px;\r\n    border-radius: 10px;\r\n    padding: 14px 11px;\r\n    font-size: 14px;\r\n    margin: 2px 0px;\r\n  }\r\n\r\n  .dropDownPanel :global(.p-dropdown-item.p-highlight:after) {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .multiSelectWrapper {\r\n    margin-bottom: 38px;\r\n  }\r\n\r\n  .multiSelectWrapper.allergiesWrapper {\r\n    margin-bottom: 38px;\r\n  }\r\n\r\n  .multiSelectWrapper :global(.p-multiselect) {\r\n    border-radius: 16px;\r\n  }\r\n\r\n  .multiSelectWrapper :global(.p-multiselect-label) {\r\n    padding: 13px 22px;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .multiSelectPanel {\r\n    border-radius: 16px;\r\n    padding: 18px 11px;\r\n  }\r\n\r\n  .multiSelectPanel :global(.p-multiselect-items-wrapper) {\r\n    max-height: 270px !important;\r\n  }\r\n\r\n  .multiSelectPanel :global(.p-multiselect-items) {\r\n    margin: 0px;\r\n    padding: 0px;\r\n  }\r\n\r\n  .multiSelectPanel :global(.p-multiselect-items) li {\r\n    height: 60px;\r\n    border-radius: 4px;\r\n    margin: 2px 0px;\r\n  }\r\n\r\n  .withOutImage.multiSelectPanel :global(.p-multiselect-items) li {\r\n    height: 38px;\r\n    border-radius: 10px;\r\n    margin: 2px 0px;\r\n    padding: 14px 11px;\r\n  }\r\n\r\n  .multiSelectPanel :global(.p-multiselect-item.p-highlight:after) {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .textArea {\r\n    border-radius: 16px;\r\n    height: 88px;\r\n    padding: 12px;\r\n    margin-bottom: 38px;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .submitButton {\r\n    border-radius: 16px;\r\n    font-size: 16px;\r\n    padding: 17px;\r\n  }\r\n\r\n  .orderCreated {\r\n    font-size: 16px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var multiSelect = `WbZuOLWS5ApyyhQ2`;
export var pageWrapper = `VZHlKgu68EEw64on`;
export var orderCard = `dpkk74qp6Y3Fm_ys`;
export var stationImage = `iUSCNbNBN_AKZ2ay`;
export var backButton = `ng9nWfvs7eczbfsS`;
export var estimatedTime = `Akx7howLSa4SK_X2`;
export var formWrapper = `c9CyMaHBZUoq0KCJ`;
export var orderRestrictions = `Yg5DQ9eBnMGpd6x6`;
export var nameWrapper = `qiWes9zanxURGKWr`;
export var label = `gxq4nhNttNEZ2vuO`;
export var maxOptionsLabel = `jpFZDGQrtCY2ZLUL`;
export var allergenToggleRow = `u7nYnngWq4nkyfI0`;
export var allergenCheckbox = `eKl8wzMf9hgrzbzR`;
export var allergenToggleLabel = `SFJwRya67wQcsO3N`;
export var inputWrapper = `e71OuuFDcUp_JTYC`;
export var input = `th4KfdegYq0C1K1b`;
export var phonePrefix = `qfAcp3qZY9EUhPZX`;
export var phoneInput = `ZESGPvB4Sa0KT3qF`;
export var listItem = `H05UKXOudQYDl3gF`;
export var listItemLabel = `KvIIRVZU1KcpFgSP`;
export var dropDownWrapper = `UMh600JkgoQpb5w3`;
export var notificationDropdown = `QpMFRGTy1iIjQfuh`;
export var notificationDropdownSelected = `IgzaZwb6KQNUUBVZ`;
export var dropDownPanel = `XVcT5ZpA_QI7xSMI`;
export var withOutImage = `dNoS3SUkuXEVVoWI`;
export var multiSelectWrapper = `QCn2pSDRDwn9ml2e`;
export var allergiesWrapper = `FZUlWTAttbkUNHm2`;
export var multiSelectPanel = `pKQqnIEAswxWr1rQ`;
export var textArea = `j2WOSF_wAvo5UIKe`;
export var orderPageInput = `DwMAiD0cZXg3vyWF`;
export var mobileSelectBtn = `X2Dr0yjXwCI2rV0e`;
export var mobileSelectBtnText = `BY3M6mZ5hgkatAYT`;
export var chipsWrapper = `wEzXo3nqvmI_8PPc`;
export var error = `GAfoVOi6MOoPN02J`;
export var submitButton = `aYKTEFsLkHw7yA3a`;
export var orderCreated = `Na8cjWJQlBouwLSN`;
export var pushMobileInfoText = `mdeS5tvQk5EnO50b`;
export var installLink = `JVOEmHexfZoUU5ft`;
export var stationInfo = `QfGsdYq3r3ELjIh_`;
export var phoneNote = `CoAkmPJ9RfsToAAF`;
export default ___CSS_LOADER_EXPORT___;
